import axios from 'axios';
import config from '../common/config';

export default {
  getRecent( token ) {
    return axios.get(`${config.config.ROOT_URL}/api/admin/whatsapp_conversations`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  getConversation( token, phone ) {
    return axios.get(`${config.config.ROOT_URL}/api/admin/whatsapp_conversation`, {
      params: { phone },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  sendDemoItinerary( token, phone ) {
    return axios.post(`${config.config.ROOT_URL}/api/admin/whatsapp_send_demo_itinerary`, { phone }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
